<div class="support">
  <div class="main-content main-content-support-form">

    <div class="container">
      <div class="row justify-content-center">
        <div class="col-lg-8">
          <mat-card class="example-card">
            <mat-card-header>
              <mat-card-title>
                <h4>Contact form</h4>
              </mat-card-title>
            </mat-card-header>
            <mat-card-content class="edge-to-edge">
              <iframe class="w-100" style="height: 1100px;" frameborder="0" src="https://app.smartsheet.com/b/form?EQBCT=b5974fc6d1d544b588348d816f70ccbd"></iframe>
            </mat-card-content>
          </mat-card>
        </div>
      </div>
    </div>
  </div>
</div>
